export default {
  appId: '96be2836-501a-42e3-9d7a-a25de348d706', // '75df54b3-f480-423a-b258-83cc0e4407be', // '5baaecf1-3fcb-409d-b23b-a863965672fe', //     ,//
  consentFqdn: 'blockv.uk', // 'blockv.lizardsoftherock.com',
  redirectUrl: `${window.location.protocol}//${window.location.host}${window.location.pathname}`, // 'https://vatom.app/builder/', // 'http://localhost:1234/', //
  autoSendVerificationCode: true,
  mapBoxToken:
    'pk.eyJ1IjoiYmt2cyIsImEiOiJja2E4OTg3MGUwYXlsMnRta2x4Yzdtbnh6In0.nf0CTt4mfERZxyEQDWUPxg',
};
